import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

const Root = styled.div`
  position: relative;
`;
const Children = styled(Horizontal).attrs({ center: true })`
  width: 100%;
  position: absolute;
  inset: 0;
  align-items: center;
`;

type Props = { border?: boolean; children?: ReactNode };

export const SeasonHexagon = ({ border, children }: Props) => {
  return (
    <Root>
      <svg
        width="57"
        height="66"
        viewBox="0 0 57 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_8100_34212"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="57"
          height="65"
        >
          <path
            d="M0.607671 16.9916L0.607668 48.9916L28.6077 64.9999L56.6077 48.9916L56.6077 16.9916L28.6077 0.999923L0.607671 16.9916Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_8100_34212)">
          <g style={{ mixBlendMode: 'plus-lighter' }} opacity="0.3">
            <rect
              x="-103"
              y="-64"
              width="506.948"
              height="242"
              fill="url(#paint0_linear_8100_34212)"
            />
            <rect
              x="-103"
              y="-64"
              width="506.948"
              height="242"
              fill="black"
              fillOpacity="0.1"
            />
          </g>
        </g>
        <path
          d="M0.607671 16.9913L0.607668 48.9913L28.6077 64.9996L56.6077 48.9913L56.6077 16.9914L28.6077 0.999678L0.607671 16.9913Z"
          stroke="url(#paint1_linear_8100_34212)"
          strokeWidth="0.332467"
          strokeMiterlimit="10"
        />
        <path
          d="M1.22028 16.9113L28.7703 1.00004L13.4691 12.831L18.1849 14.2375L1.22028 16.9113Z"
          fill={border ? 'url(#paint2_linear_8100_34212)' : 'var(--c-nd-150)'}
        />
        <path
          d="M56.9031 48.8934L28.9186 65.0992L44.1417 53.5165L39.4258 52.11L56.9031 48.8934Z"
          fill={border ? 'url(#paint3_linear_8100_34212)' : 'var(--c-nd-150)'}
        />
        <path
          d="M56.2638 16.8251L28.7139 0.913855L44.0151 12.7448L39.2992 14.1513L56.2638 16.8251Z"
          fill={border ? 'url(#paint4_linear_8100_34212)' : 'var(--c-nd-150)'}
        />
        <path
          d="M0.785402 48.8934L28.7699 65.0992L13.5468 53.5165L18.2626 52.11L0.785402 48.8934Z"
          fill={border ? 'url(#paint5_linear_8100_34212)' : 'var(--c-nd-150)'}
        />
        <defs>
          <linearGradient
            id="paint0_linear_8100_34212"
            x1="-103"
            y1="178"
            x2="431.298"
            y2="62.2793"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F8D3DA" />
            <stop offset="0.283178" stopColor="#B3A9F4" />
            <stop offset="0.5401" stopColor="#FBE9FB" />
            <stop offset="1" stopColor="#4F94FD" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_8100_34212"
            x1="28.6077"
            y1="-857.27"
            x2="28.6077"
            y2="-857.27"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.19" stopColor="#E8E0FB" />
            <stop offset="0.76" stopColor="#E8E0FB" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_8100_34212"
            x1="28.7703"
            y1="1.00004"
            x2="-0.684171"
            y2="6.27291"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F8D3DA" />
            <stop offset="0.283178" stopColor="#B3A9F4" />
            <stop offset="0.5401" stopColor="#FBE9FB" />
            <stop offset="1" stopColor="#4F94FD" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_8100_34212"
            x1="56.9031"
            y1="48.8934"
            x2="26.9791"
            y2="54.2359"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F8D3DA" />
            <stop offset="0.283178" stopColor="#B3A9F4" />
            <stop offset="0.5401" stopColor="#FBE9FB" />
            <stop offset="1" stopColor="#4F94FD" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_8100_34212"
            x1="28.7139"
            y1="0.913857"
            x2="58.1683"
            y2="6.18674"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F8D3DA" />
            <stop offset="0.283178" stopColor="#B3A9F4" />
            <stop offset="0.5401" stopColor="#FBE9FB" />
            <stop offset="1" stopColor="#4F94FD" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_8100_34212"
            x1="0.785402"
            y1="48.8934"
            x2="30.7094"
            y2="54.2359"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F8D3DA" />
            <stop offset="0.283178" stopColor="#B3A9F4" />
            <stop offset="0.5401" stopColor="#FBE9FB" />
            <stop offset="1" stopColor="#4F94FD" />
          </linearGradient>
        </defs>
      </svg>
      {!!children && <Children>{children}</Children>}
    </Root>
  );
};
